<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb" v-if="project">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: project.id}}">Project Overview</router-link></li>
              <li><router-link :to="{name: 'Search'}">Search</router-link></li>
              <li class="active">
                <span>History</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Search History
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="hpanel">
        <div class="panel-heading">
          Last Queries
          <div class="pull-right text-right">
            <div class="btn-group">
              <router-link class="btn btn-info btn-xs" :to="{name: 'Search'}">Back to explore</router-link>
            </div>
          </div>
        </div>
        <div class="panel-body">
          <div class="table-responsive">
            <table class="table table-condensed">
              <thead>
              <tr>
                <th>Query</th>
                <th>Date</th>
                <th>Sources</th>
                <th>Type Search</th>
                <th>Date Range</th>
                <th>Nb Documents</th>
                <th>Countries</th>
                <th>SubProject</th>
                <th>Project</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="queries && queries.length !== 0">
                <tr v-for="(query, key) in queries" :key="key">
                  <td><router-link :to="getRoute(query)">{{query.search_terms.term}}</router-link></td>
                  <td>{{query.updated_at | moment('LLL')}}</td>
                  <td>{{displaySource(query)}}</td>
                  <td>{{displayDocumentType(query)}}</td>
                  <td>{{displayDate(query)}}</td>
                  <td>{{ query.document_type === 4 || query.document_type === 5 ? 'N/A' : query.nb_documents }}</td>
                  <td>{{displayCountries(query)}}</td>
                  <td><template v-if="query.list">{{query.list.title}}</template></td>
                  <td><template v-if="query.list && query.list.projects[0]">{{query.list.projects[0].name}}</template></td>
                </tr>
              </template>
              <template v-else>
                <tr >
                  <td colspan="9" class="text-center">no queries performed yet</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import Search from '../../components/Mixins/Search'
import {cleanQueryFromTagsinputToSearch, formatSearchForUrl} from '../../assets/scripts/search'

export default {
  mixins: [Search],
  components: {
  },
  name: 'SearchHistory',
  props: ['listId'],
  data () {
    return {
      queries: [],
      project: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('search/history?limit=200&relations={list.projects}').then((response) => {
        this.queries = response.data
      })
    },
    displaySource: function (query) {
      return query.sources.join(', ')
    },
    displayDocumentType: function (query) {
      let displayDocumentType = ''

      switch (query.document_type) {
        case 0:
          displayDocumentType = 'science'
          break
        case 1:
          displayDocumentType = 'patent'
          break
        case 3:
          displayDocumentType = 'company'
          break
        case 4:
          displayDocumentType = 'news'
          break
        case 5:
          displayDocumentType = 'AI chat'
          break
      }
      return displayDocumentType
    },
    displayDate: function (query) {
      let displayDate = ''

      if (query.date !== null) {
        displayDate += query.date['to'] + ' - ' + query.date['from']
      }
      return displayDate
    },
    displayCountries: function (query) {
      return (Array.isArray(query.countries) === true && query.countries !== null) ? query.countries.join(', ') : ''
    },
    getRoute: function (query) {
      let queryParams = this.prepareSearchWithAdvancedQuery(query)

      queryParams.typeSearched = query.document_type

      let queryClean = cleanQueryFromTagsinputToSearch(query.search_terms.term)
      let queryUrl = formatSearchForUrl(queryClean)

      return { name: 'Search', params: {query: queryUrl}, query: queryParams }
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/search/History.vue